@if (isLoading()) {
  <section
    class="fixed inset-0 z-[9999] flex items-center justify-center bg-[#E3EBF0CC] text-primary-700"
    role="status"
    aria-live="polite"
    aria-busy="true"
    aria-label="Loading content">
    <div class="h-14 w-14 rounded-lg relative">
      <img
        ngSrc="assets/loader-logo.png"
        alt="CCS logo"
        fill
        priority
        class="object-contain" />
    </div>
    <article
      class="absolute h-36 w-36 animate-spin rounded-full border-t border-b border-primary-700"
      aria-hidden="true"></article>
  </section>
}
